import client from './client';
const projectFragment = `
{
  _id,
  ...,
  mainImage{
    ...,
    asset->{url}
  },
  additionalImages[]{
    ...,
    alt,
    asset->{url}
  },
  certifiedBy[]->{
    title->{textContent},
    description->{textContent},
    logo{
      asset->{url}
    }
  },
  sdgs[]{
    affect,
    sdg->{
      ...,
      backgroundImage{
        asset->{url}
      },
      icon{
        asset->{url}
      }
    }
  }
}`;
export const getProjects = async (portfolioId: string): Promise<SanityPortfolio[]> => {
  const query = `*[_id == "${portfolioId}"]{
    title->{textContent},
    subtitle->{textContent},
    description->{textContent},
    currency,
    pricePerImpactUnit,
    portfolioSegment->{
      title
    },
    portfolioTheme->{title},
    mainImage{
      ...,
      asset->{url, alt}
    },
    vatByCountry,
    'projects':projects[]->${projectFragment}
  }`;

  const data = await client.fetch<SanityPortfolio[]>(query);
  return data;
};

export const getProjectBySlug = async (slug: string): Promise<SanityProject> => {
  const query = `*[slug.current == "${slug}"][0]${projectFragment}`;
  const data = await client.fetch<SanityProject>(query);
  return data;
};

export const getAllPortfolios = async (): Promise<SanityPortfolio[]> => {
  const query = `*[_type == 'portfolio']{
    _id,
    title->{textContent},
    subtitle->{textContent},
    description->{textContent},
    portfolioSegment->{
      title
    },
    pricePerImpactUnit,
    currency,
    portfolioTheme->{title},
    mainImage{
      ...,
      asset->{url, alt}
    },
    vatByCountry,
    'projects':projects[]->${projectFragment}
  }`;

  const data = await client.fetch<SanityPortfolio[]>(query);
  return data;
};

export const getPortfoliosFromIds = async (ids: string[]): Promise<SanityPortfolio[]> => {
  const query = `*[_type == 'portfolio' && _id in [${ids.map(item => `"${item}"`)}]]{
    _id,
    title->{textContent},
    subtitle->{textContent},
    description->{textContent},
    portfolioSegment->{
      title
    },
    pricePerImpactUnit,
    currency,
    portfolioTheme->{title},
    mainImage{
      ...,
      asset->{url, alt}
    },
    vatByCountry,
    'projects':projects[]->${projectFragment}
  }`;

  const data = await client.fetch<SanityPortfolio[]>(query);
  return data;
};

export const getAllProjects = async (): Promise<SanityProject[]> => {
  const query = `*[_type == 'project']${projectFragment}`;

  const data = await client.fetch<SanityProject[]>(query);

  return data;
};
